import { equalWithinTolerance } from './equalsWithinTolerance';

export const distributedForceToleranceInPoundsPerFoot = 0.005;

export function distributedForceEquals(
  distributedForceOneInPoundsPerFoot: number,
  distributedForceTwoInPoundsPerFoot: number,
) {
  return equalWithinTolerance(
    distributedForceOneInPoundsPerFoot,
    distributedForceTwoInPoundsPerFoot,
    distributedForceToleranceInPoundsPerFoot,
  );
}

export function distributedForceGreaterThanOrEqual(
  distributedForceOneInPoundsPerFoot: number,
  distributedForceTwoInPoundsPerFoot: number,
) {
  return (
    distributedForceOneInPoundsPerFoot >= distributedForceTwoInPoundsPerFoot ||
    distributedForceEquals(distributedForceOneInPoundsPerFoot, distributedForceTwoInPoundsPerFoot)
  );
}

export function distributedForceLessThanOrEqual(
  distributedForceOneInPoundsPerFoot: number,
  distributedForceTwoInPoundsPerFoot: number,
) {
  return (
    distributedForceOneInPoundsPerFoot <= distributedForceTwoInPoundsPerFoot ||
    distributedForceEquals(distributedForceOneInPoundsPerFoot, distributedForceTwoInPoundsPerFoot)
  );
}

export function distributedForceGreaterThan(
  distributedForceOneInPoundsPerFoot: number,
  distributedForceTwoInPoundsPerFoot: number,
) {
  return !distributedForceLessThanOrEqual(distributedForceOneInPoundsPerFoot, distributedForceTwoInPoundsPerFoot);
}

export function distributedForceLessThan(
  distributedForceOneInPoundsPerFoot: number,
  distributedForceTwoInPoundsPerFoot: number,
) {
  return !distributedForceGreaterThanOrEqual(distributedForceOneInPoundsPerFoot, distributedForceTwoInPoundsPerFoot);
}
